export var CompensationObjectTypeMixin = {
  methods: {
    translateCompensationObjectType(compensationObjectType) {
      return this.$t(`mixins.compensationObjectTypesMixin.objectTypes.${compensationObjectType}`)
    }
  }
}
